import { useEffect, useRef } from "react";

export function Cursor() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    const d = dot.current;
    const r = ring.current;
    let rx = 0, ry = 0, mx = 0, my = 0;
    const move = (e) => {
      mx = e.clientX; my = e.clientY;
      if (d) { d.style.transform = `translate(${mx}px, ${my}px)`; }
      const t = e.target;
      const interactive = t.closest("a, button, [role=button], input, textarea, select, label");
      if (r) r.dataset.hot = interactive ? "1" : "0";
    };
    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (r) r.style.transform = `translate(${rx}px, ${ry}px)`;
      raf = requestAnimationFrame(loop);
    };
    let raf = requestAnimationFrame(loop);
    window.addEventListener("mousemove", move);
    return () => { window.removeEventListener("mousemove", move); cancelAnimationFrame(raf); };
  }, []);

  return (
    <>
      <div ref={dot} className="hidden lg:block fixed top-0 left-0 z-[9999] pointer-events-none -ml-[2px] -mt-[2px]">
        <div className="w-1 h-1 bg-ember rounded-full" />
      </div>
      <div
        ref={ring}
        data-hot="0"
        className="hidden lg:block fixed top-0 left-0 z-[9998] pointer-events-none -ml-4 -mt-4 w-8 h-8 rounded-full border border-white/30 transition-[width,height,opacity,border-color] duration-300 data-[hot='1']:border-ember data-[hot='1']:scale-150"
      />
    </>
  );
}
